import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var PriceTagWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  display: inline-flex;\n  align-items: flex-start;\n  flex-direction: column;\n  font-family: ", ";\n  font-weight: ", ";\n"], ["\n  color: ", ";\n  display: inline-flex;\n  align-items: flex-start;\n  flex-direction: column;\n  font-family: ", ";\n  font-weight: ", ";\n"])), function (_a) {
  var fontColor = _a.fontColor;
  return fontColor;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.typography) === null || _b === void 0 ? void 0 : _b.type.primary;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.typography) === null || _b === void 0 ? void 0 : _b.weight.extraBold;
});
var PriceStripeContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 1px;\n  transform: rotate(-", "deg);\n"], ["\n  margin-bottom: 1px;\n  transform: rotate(-", "deg);\n"])), function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.constants) === null || _b === void 0 ? void 0 : _b.priceRotate;
});
var PriceTagContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: ", "px\n    ", "px;\n  position: relative;\n"], ["\n  background-color: ", ";\n  padding: ", "px\n    ", "px;\n  position: relative;\n"])), function (_a) {
  var backgroundColor = _a.backgroundColor;
  return backgroundColor;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xxs;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xs;
});
var PriceTag = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", "px;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", "px;\n"])), function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xxxs;
});
var PriceBase = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: ", "px;\n  letter-spacing: ", "rem;\n  line-height: 1;\n"], ["\n  font-size: ", "px;\n  letter-spacing: ", "rem;\n  line-height: 1;\n"])), function (_a) {
  var fontSize = _a.fontSize;
  return fontSize;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.constants) === null || _b === void 0 ? void 0 : _b.priceBaseLetterSpacing;
});
var PriceDetails = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: ", "px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: ", "px;\n"])), function (_a) {
  var width = _a.width;
  return width;
});
var PriceIndicatorContainer = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin-top: ", "px;\n"], ["\n  margin-top: ", "px;\n"])), function (_a) {
  var isSmall = _a.isSmall,
      showUnit = _a.showUnit;
  return showUnit ? isSmall ? -7 : -5 : isSmall ? 3 : 5;
});
var PriceDecimals = styled.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  font-size: ", "px;\n  margin-top: ", "px;\n"], ["\n  font-size: ", "px;\n  margin-top: ", "px;\n"])), function (_a) {
  var fontSize = _a.fontSize;
  return fontSize;
}, function (_a) {
  var isSmall = _a.isSmall;
  return isSmall ? -11 : -14;
});
var PriceUnit = styled.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  font-size: ", "px;\n  font-weight: ", ";\n  position: absolute;\n  bottom: ", "px;\n  right: ", "px;\n"], ["\n  font-size: ", "px;\n  font-weight: ", ";\n  position: absolute;\n  bottom: ", "px;\n  right: ", "px;\n"])), function (_a) {
  var fontSize = _a.fontSize;
  return fontSize;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.typography) === null || _b === void 0 ? void 0 : _b.weight.bold;
}, function (_a) {
  var isSmall = _a.isSmall;
  return isSmall ? 4 : 6;
}, function (_a) {
  var pant = _a.pant;
  return pant ? 4 : 7;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
export { PriceBase, PriceDecimals, PriceDetails, PriceIndicatorContainer, PriceStripeContainer, PriceTag, PriceTagContainer, PriceTagWrapper, PriceUnit };